import { useTranslation } from '@/lib/i18n/i18n.client';
import { cn } from '@/lib/utils';

import { SvgIcon } from '@/components/SvgIcon';

import Button from '@/components/atoms/Button';
import Heading from '@/components/atoms/Heading';
import { Text } from '@/components/atoms/Text';

import iconFaceContentSrc from '~/icons/face-content.svg';

type SuccessPageProps = {
  onSubmit?: () => void;
  isModal?: boolean;
};

export function SuccessPage({ onSubmit, isModal }: SuccessPageProps) {
  const { lang, texts } = useTranslation();

  return (
    <div
      data-tracker='submission-status_success'
      className={cn(
        'flex flex-col items-start justify-center md:h-full lg:items-center',
        isModal && 'lg:items-start'
      )}
    >
      <div
        className={cn(
          'mb-6 flex w-full items-center justify-start gap-4 lg:justify-center',
          isModal && 'lg:justify-start'
        )}
      >
        <SvgIcon
          src={iconFaceContentSrc}
          className='text-success-500 h-8 w-8 shrink-0'
        />

        <Heading level='h3'>
          {texts.contact_sales.success.sent_successfully}
        </Heading>
      </div>
      <Text
        color='gray-dark-500'
        classNames={{
          wrapper: cn('mb-9 md:text-center', isModal && 'lg:text-left'),
        }}
      >
        {texts.contact_sales.success.message_decodo}
      </Text>

      {onSubmit && lang !== 'zh-cn' && (
        <Button
          classNames={{
            root: cn(
              'w-full md:w-fit md:min-w-[320px]',
              isModal && 'lg:w-full'
            ),
          }}
          onClick={onSubmit}
        >
          {texts.contact_sales.success.book_demo_call}
        </Button>
      )}
    </div>
  );
}
